import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Table, Row, Col, Card, CardBody, Input, Badge, Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const InventoryList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [inventory, setInventory] = useState([]);
    const [summary, setSummary] = useState({ total_stock: 0 });
    const [pagination, setPagination] = useState({ current_page: 1, total_pages: 1 });

    const [filters, setFilters] = useState({
        search: "",
        min_stock: "",
        max_stock: "",
        page: 1,
        limit: 10
    });

    const loadInventory = async () => {
        dispatch(loadingTrue());
        try {
            const queryParams = new URLSearchParams(filters).toString();
            const res = await Handler({ method: "GET", url: `/product/list.php?${queryParams}` });

            if (res?.success) {
                setInventory(res?.data || []);
                setSummary(res?.summary || { total_stock: 0 });
                setPagination({
                    current_page: res.page,
                    total_pages: res.total_pages,
                    total_records: res.total
                });
                dispatch(loadingFalse());
            } else {
                toast.error(res?.message || "Failed to fetch inventory");
                dispatch(loadingFalse());
            }
        } catch (err) {
            toast.error("Server connection error");
        } finally {
            dispatch(loadingFalse());
        }
    };

    // 🔥 Machan, DB Status use panni Toggle Logic
    const handleStatusToggle = async (id, currentDbStatus) => {
        const newStatus = currentDbStatus == 1 ? 0 : 1; // 1 na Active, 0 na Inactive
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to ${newStatus === 1 ? 'Activate' : 'Deactivate'} this product?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#2e4a3d',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Update Status'
        });

        if (result.isConfirmed) {
            dispatch(loadingTrue());
            try {
                const res = await Handler({
                    method: "POST",
                    url: "/product/update.php",
                    data: { id: id, status: newStatus }
                });

                if (res?.success) {
                    toast.success(`Product ${newStatus === 1 ? 'Activated' : 'Deactivated'}`);
                    loadInventory(); // List refresh
                    dispatch(loadingFalse());
                } else {
                    toast.error(res?.message || "Status update failed");
                    dispatch(loadingFalse());
                }
            } catch (e) {
                toast.error("Error updating status");
            } finally {
                dispatch(loadingFalse());
            }
        }
    };

    useEffect(() => { loadInventory(); }, [filters.page]);

    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value, page: 1 });
    };

    const handleSearch = (e) => { if (e.key === 'Enter') loadInventory(); };

    return (
        <div className="page-container p-3 bg-light min-vh-100">
            <div className="page-header mb-4">
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <h3 className="fw-bold m-0">Current Stock Inventory</h3>
                        <p className="text-muted small">Real-time stock monitoring and product control.</p>
                    </div>
                    <div className="text-end bg-white p-3 rounded-4 shadow-sm border-start border-4 border-success">
                        <small className="text-muted text-uppercase fw-bold">Total Mill Stock</small>
                        <h4 className="fw-bold text-success m-0">{summary.total_stock?.toLocaleString()} KG</h4>
                    </div>
                </div>
            </div>

            <Card className="border-0 shadow-sm rounded-4 mb-4">
                <CardBody className="p-3">
                    <Row className="g-3 align-items-center">
                        <Col md={4}><Input name="search" className="bg-light border-0 py-2" placeholder="🔍 Search product..." value={filters.search} onChange={handleFilterChange} onKeyDown={handleSearch} /></Col>
                        <Col md={3}><Input type="number" name="min_stock" className="bg-light border-0 py-2" placeholder="Min Stock" value={filters.min_stock} onChange={handleFilterChange} /></Col>
                        <Col md={3}><Input type="number" name="max_stock" className="bg-light border-0 py-2" placeholder="Max Stock" value={filters.max_stock} onChange={handleFilterChange} /></Col>
                        <Col md={2}><Button color="primary" block className="fw-bold" onClick={loadInventory}>Filter</Button></Col>
                    </Row>
                </CardBody>
            </Card>

            <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
                <CardBody className="p-0">
                    <Table responsive hover className="mb-0 text-center align-middle">
                        <thead className="bg-light text-muted small text-uppercase ls-1">
                            <tr>
                                <th className="ps-4 text-start py-3">S.No</th>
                                <th className="text-start">Product Details</th>
                                <th>Available Stock</th>
                                <th>Active Status</th>
                                <th>Inventory Status</th>
                                <th className="pe-4">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {inventory.length > 0 ? (
                                inventory.map((item, index) => (
                                    <tr key={item.id}>
                                        <td className="ps-4 text-start">{(filters.page - 1) * filters.limit + index + 1}</td>
                                        <td className="text-start">
                                            <div className="fw-bold text-dark">{item.name?.toUpperCase()}</div>
                                            <small className="text-muted">UID: #{item.id}</small>
                                        </td>
                                        <td>
                                            <div className="fw-bold text-primary fs-6">{parseFloat(item.total_kg)?.toLocaleString()} KG</div>
                                        </td>
                                        <td>
                                            {/* 🔥 Machan, DB Status Switch correct-ah map panniyachu */}
                                            <div className="form-check form-switch d-flex justify-content-center">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    checked={item.db_status == 1}
                                                    onChange={() => handleStatusToggle(item.id, item.db_status)}
                                                    style={{ cursor: 'pointer', transform: 'scale(1.2)' }}
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            {/* Machan, logic based on db_status and stock */}
                                            {item.db_status == 0 ? (
                                                <Badge color="soft-dark" className="text-dark rounded-pill px-3">Inactive</Badge>
                                            ) : item.total_kg > 1000 ? (
                                                <Badge color="soft-success" className="text-success rounded-pill px-3">In Stock</Badge>
                                            ) : item.total_kg > 0 ? (
                                                <Badge color="soft-warning" className="text-warning rounded-pill px-3">Low Stock</Badge>
                                            ) : (
                                                <Badge color="soft-danger" className="text-danger rounded-pill px-3">Out of Stock</Badge>
                                            )}
                                        </td>
                                        <td className="pe-4">
                                            <Button color="white" className="btn-icon shadow-sm border rounded-pill" onClick={() => navigate(`/products/${item.id}`)}>
                                                <i className="bx bx-edit text-info fs-5"></i>
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="6" className="text-center py-5 text-muted">No inventory records found.</td></tr>
                            )}
                        </tbody>
                    </Table>
                </CardBody>
            </Card>

            {pagination?.total_pages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                    <Pagination size="sm">
                        <PaginationItem disabled={filters.page <= 1}><PaginationLink previous onClick={() => setFilters({ ...filters, page: filters.page - 1 })} /></PaginationItem>
                        {[...Array(pagination?.total_pages)].map((_, i) => (
                            <PaginationItem active={i + 1 === filters.page} key={i}>
                                <PaginationLink onClick={() => setFilters({ ...filters, page: i + 1 })}>{i + 1}</PaginationLink>
                            </PaginationItem>
                        ))}
                        <PaginationItem disabled={filters.page >= pagination?.total_pages}><PaginationLink next onClick={() => setFilters({ ...filters, page: filters.page + 1 })} /></PaginationItem>
                    </Pagination>
                </div>
            )}
        </div>
    );
};

export default InventoryList;